import React from 'react'
import { Well, Table, Button } from 'react-bootstrap'
import Icon from '_/shared/components/icon'
import icons from '_/config/icons.json'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import EditLandUseModal from '_/shared/components/editLandUseModal'
import { Map } from 'immutable'

@ReactMixin.decorate(ImmutableRenderMixin)
class LandUseTable extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    editable: React.PropTypes.bool,
    landUses: React.PropTypes.object.isRequired,
    metadata: React.PropTypes.object.isRequired,
    property: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    notify: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      activeIdx: null,
      isModalOpen: false,
      activeLandUse: Map()
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      activeIdx: null,
      isModalOpen: false,
      activeLandUse: Map()
    }
  }

  handleLandUseOpen (landUse, idx, evt) {
    evt.preventDefault()
    this.setState({
      activeIdx: idx,
      activeLandUse: landUse,
      isModalOpen: true
    })
  }

  handleLandUseAdd (landUse) {
    const { landUses, onChange } = this.props
    onChange(landUses.push(landUse))
  }

  handleLandUseChange (landUse) {
    const { landUses, onChange } = this.props
    const { activeIdx } = this.state
    onChange(landUses.set(activeIdx, landUse))
  }

  handleLandUseDelete (landUse) {
    const { landUses, onChange } = this.props
    const { activeIdx } = this.state
    onChange(landUses.delete(activeIdx))
  }

  async share (landUse, idx, evt) {
    evt.preventDefault()
    const { property, landUses, onChange } = this.props
    const { store, notify } = this.context
    const id = property.get('id')
    const landUseId = landUse.get('id')

    try {
      const sharedLandUse = await store.post(`/properties/${id}/landUse/${landUseId}/share`)
      notify('Land use shared')
      onChange(landUses.set(idx, sharedLandUse))
    } catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  handleModalClose () {
    this.setState({
      activeIdx: null,
      isModalOpen: false,
      activeLandUse: Map()
    })
  }

  renderEdit (landUse, idx) {
    const { editable } = this.props
    if (!editable) return null

    return (
      <td>
        <a href="" onClick={this.handleLandUseOpen.bind(this, landUse, idx)}>
          <Icon name={icons.edit} fixedWidth />
        </a>
      </td>
    )
  }

  renderShare (landUse, idx) {
    const { account, property } = this.props
    const isPrivate = property.get('isPrivate')
    const isPrivateLandUse = landUse.get('isPrivate')
    const isShared = landUse.has('shareId')

    if (isShared) {
      return (
        <td><i>Shared</i></td>
      )
    }

    if (isPrivate && !isPrivateLandUse) {
      return (
        <td><i>Public</i></td>
      )
    }

    const canShare =
      isPrivate && // Can only share private record
      isPrivateLandUse && // Can only share private land use
      property.has('public') && // Has a public record to share with
      account.getIn(['group', 'type']) === 'Point' && // Only from a point group
      !property.get('unsharable') // Must not be marked as unshareable

    if (!canShare) return null

    return (
      <td>
        <a href="#" onClick={this.share.bind(this, landUse, idx)}>
          Share publicly
        </a>
      </td>
    )
  }

  renderLandUse (landUse, idx) {
    const { editable, account } = this.props
    const canEdit = landUse.get('isPrivate') || account.get('isAdmin')
    if (editable && !canEdit) return null

    return (
      <tr key={idx}>
        {this.renderEdit(landUse, idx)}
        <td>{landUse.get('use')}</td>
        <td>{landUse.get('deedAcresCt')}</td>
        <td>{landUse.get('topoT')}</td>
        <td>{landUse.get('ratioPct')}</td>
        {this.renderShare(landUse, idx)}
      </tr>
    )
  }

  render () {
    const { landUses, metadata, property, editable } = this.props
    const { activeLandUse, isModalOpen } = this.state

    const landUseExist = landUses.size !== 0
    if (!landUseExist && !editable) return null

    return (
      <Well style={{padding: 8}}>
        <h4><b>Land uses</b>&nbsp;
          {editable &&
            <Button
              bsSize="xsmall"
              bsStyle="success"
              onClick={this.handleLandUseOpen.bind(this, Map(), null)}>
              Add new
            </Button>
          }
        </h4>
        {landUseExist &&
          <Table className="redi-component-table">
            <thead>
              <tr>
                {editable && <th width={30} />}
                <th>Land use</th>
                <th>Deeded acres</th>
                <th>Topography</th>
                <th>Ratio</th>
              </tr>
            </thead>
            <tbody>
              {landUses.map(::this.renderLandUse)}
            </tbody>
          </Table>
        }

        {!landUseExist &&
          <p>
            There are no land uses attached to this property. <a href="" onClick={this.handleLandUseOpen.bind(this, Map(), null)}>Create an land use</a>
          </p>
        }

        <EditLandUseModal
          show={isModalOpen}
          property={property}
          landUse={activeLandUse}
          metadata={metadata}
          onAdd={::this.handleLandUseAdd}
          onChange={::this.handleLandUseChange}
          onRemove={::this.handleLandUseDelete}
          onHide={::this.handleModalClose} />
      </Well>
    )
  }
}

export default LandUseTable



// WEBPACK FOOTER //
// ./modules/shared/components/landUseTable.js